// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"xQ-z","inlineTitle":"yQ-z","sponsoredAdsWrapper":"zQ-z","marketplaceRecosWrapper":"AQ-z"};